var _defs, _text, _path, _path2, _path3, _path4, _rect, _path5, _text2, _text3, _rect2, _text4, _text5, _text6, _text7, _text8, _text9, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _g, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _g2, _g3, _rect26, _rect27, _rect28, _g4, _g5, _g6, _g7, _g8, _rect29, _path6, _path7, _path8, _path9, _circle, _g9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlaceholder5(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 823.271,
    height: 441.825,
    viewBox: "0 0 823.271 441.825",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -5.197,
    y1: 0.5,
    x2: -0.084,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0071bc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -220.491,
    y1: -23.704,
    x2: -218.568,
    y2: -23.704,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -228.587,
    y1: -11.783,
    x2: -225.028,
    y2: -11.783,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 0.5,
    y1: 0.791,
    x2: 0.5,
    y2: 0.238,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f44522"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: -1.097,
    y1: -3.73,
    x2: 0.948,
    y2: -3.73,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: -7.934,
    y1: -0.558,
    x2: 0.247,
    y2: -0.558,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: -10.486,
    y1: -0.326,
    x2: -0.014,
    y2: -0.326,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fe3c38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.209,
    stopColor: "#fe3c38",
    stopOpacity: 0.988
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#fe3c38",
    stopOpacity: 0.957
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.459,
    stopColor: "#fe3c38",
    stopOpacity: 0.898
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.562,
    stopColor: "#fe3c38",
    stopOpacity: 0.816
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.656,
    stopColor: "#fe3c38",
    stopOpacity: 0.706
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746,
    stopColor: "#fe3c38",
    stopOpacity: 0.576
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#fe3c38",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.911,
    stopColor: "#fe3c38",
    stopOpacity: 0.235
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.987,
    stopColor: "#fe3c38",
    stopOpacity: 0.035
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fe3c38",
    stopOpacity: 0
  })))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    id: "\\uD48D\\uB825\\uD130\\uBE48",
    transform: "translate(0 188)",
    fill: "#fff",
    fontSize: 17,
    fontFamily: "NanumGothicExtraBold, NanumGothic"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\uD48D\uB825\uD130\uBE48"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\uC0AC\\uAC01\\uD615_332",
    "data-name": "\\uC0AC\\uAC01\\uD615 332",
    d: "M0,0H150.331a15.211,15.211,0,0,1,15.211,15.211v44.93a15.211,15.211,0,0,1-15.211,15.211H0a0,0,0,0,1,0,0V0A0,0,0,0,1,0,0Z",
    transform: "translate(112.73 142.473)",
    fill: "#ddd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "\\uC0AC\\uAC01\\uD615_333",
    "data-name": "\\uC0AC\\uAC01\\uD615 333",
    d: "M0,0H21.079a20.88,20.88,0,0,1,20.88,20.88v0a20.88,20.88,0,0,1-20.88,20.88H0a0,0,0,0,1,0,0V0A0,0,0,0,1,0,0Z",
    transform: "translate(112.73 200.613) rotate(-180)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2678",
    "data-name": "\\uD328\\uC2A4 2678",
    d: "M383.161,8830.156h-9.943v-66.333a8.038,8.038,0,0,1,8.039-8.038h0a4.2,4.2,0,0,1,4.2,4.289Z",
    transform: "translate(-276.197 -8671.303)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2679",
    "data-name": "\\uD328\\uC2A4 2679",
    d: "M383.161,8870.256h-9.943v76.333a8.039,8.039,0,0,0,8.039,8.039h0a4.2,4.2,0,0,0,4.2-4.29Z",
    transform: "translate(-276.197 -8671.303)",
    fill: "#fff"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_334",
    "data-name": "\\uC0AC\\uAC01\\uD615 334",
    width: 14.318,
    height: 21.079,
    rx: 2.099,
    transform: "translate(95.032 168.398)",
    fill: "#d6d4d4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "\\uC0AC\\uAC01\\uD615_335",
    "data-name": "\\uC0AC\\uAC01\\uD615 335",
    d: "M5.369,0H6.761a0,0,0,0,1,0,0V10.738a0,0,0,0,1,0,0H5.369A5.369,5.369,0,0,1,0,5.369v0A5.369,5.369,0,0,1,5.369,0Z",
    transform: "translate(88.271 173.568)",
    fill: "#898989"
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    id: "\\uBC1C\\uC804\\uAE30",
    transform: "translate(207 135)",
    fill: "#fff",
    fontSize: 17,
    fontFamily: "NanumGothicExtraBold, NanumGothic"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\uBC1C\uC804\uAE30"))), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    id: "\\uAE30\\uC5B4\\uBC15\\uC2A4",
    transform: "translate(126 135)",
    fill: "#fff",
    fontSize: 17,
    fontFamily: "NanumGothicExtraBold, NanumGothic"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\uAE30\uC5B4\uBC15\uC2A4"))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_336",
    "data-name": "\\uC0AC\\uAC01\\uD615 336",
    width: 265,
    height: 148,
    transform: "translate(190.271 293.825)",
    fill: "#7a7d82"
  })), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    id: "\\uCEE8\\uBC84\\uD130",
    transform: "translate(217 427)",
    fill: "#fff",
    fontSize: 17,
    fontFamily: "NanumGothicExtraBold, NanumGothic"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\uCEE8\uBC84\uD130"))), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    id: "\\uC804\\uB825\\uBCC0\\uD658\\uAE30",
    transform: "translate(367.5 279.5)",
    fill: "#fff",
    fontSize: 17,
    fontFamily: "NanumGothicExtraBold, NanumGothic"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\uC804\uB825\uBCC0\uD658\uAE30"))), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    id: "\\uC778\\uBC84\\uD130",
    transform: "translate(302 427)",
    fill: "#fff",
    fontSize: 17,
    fontFamily: "NanumGothicExtraBold, NanumGothic"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\uC778\uBC84\uD130"))), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    id: "\\uACC4\\uCE21\\uC810",
    transform: "translate(382 412)",
    fill: "#fff",
    fontSize: 17,
    fontFamily: "NanumGothicExtraBold, NanumGothic"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\uACC4\uCE21\uC810"))), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    id: "\\uBCC0\\uC555\\uAE30",
    transform: "translate(721 427)",
    fill: "#fff",
    fontSize: 17,
    fontFamily: "NanumGothicExtraBold, NanumGothic"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\uBCC0\uC555\uAE30"))), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    id: "\\uC1A1\\uC804\\uC120",
    transform: "translate(721 15)",
    fill: "#fff",
    fontSize: 17,
    fontFamily: "NanumGothicExtraBold, NanumGothic"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\uC1A1\uC804\uC120"))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_337",
    "data-name": "\\uC0AC\\uAC01\\uD615 337",
    width: 11,
    height: 125,
    transform: "translate(234.271 172.825) rotate(90)",
    fill: "url(#linear-gradient)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_338",
    "data-name": "\\uC0AC\\uAC01\\uD615 338",
    width: 11,
    height: 47,
    transform: "translate(236.271 312.824) rotate(180)",
    fill: "url(#linear-gradient-2)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_339",
    "data-name": "\\uC0AC\\uAC01\\uD615 339",
    width: 11,
    height: 87,
    transform: "translate(236.271 263.824) rotate(180)",
    fill: "url(#linear-gradient-3)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_340",
    "data-name": "\\uC0AC\\uAC01\\uD615 340",
    width: 11,
    height: 52,
    transform: "translate(751.271 205.824) rotate(180)",
    fill: "url(#linear-gradient-4)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_341",
    "data-name": "\\uC0AC\\uAC01\\uD615 341",
    width: 11,
    height: 148,
    transform: "translate(751.271 348.824) rotate(180)",
    fill: "url(#linear-gradient-4)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_342",
    "data-name": "\\uC0AC\\uAC01\\uD615 342",
    width: 11,
    height: 50,
    transform: "translate(729.271 354.825) rotate(90)",
    fill: "url(#linear-gradient-6)"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_343",
    "data-name": "\\uC0AC\\uAC01\\uD615 343",
    width: 11,
    height: 200,
    transform: "translate(680.271 354.825) rotate(90)",
    fill: "url(#linear-gradient-7)"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_344",
    "data-name": "\\uC0AC\\uAC01\\uD615 344",
    width: 11,
    height: 256,
    transform: "translate(482.271 354.825) rotate(90)",
    fill: "url(#linear-gradient-8)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1330",
    "data-name": "\\uADF8\\uB8F9 1330",
    transform: "translate(-276.197 -8671.303)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1329",
    "data-name": "\\uADF8\\uB8F9 1329"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uC0AC\\uAC01\\uD615_345",
    "data-name": "\\uC0AC\\uAC01\\uD615 345",
    d: "M.7,0H12.961a.7.7,0,0,1,.7.7v.583a.278.278,0,0,1-.278.278H.278A.278.278,0,0,1,0,1.282V.7A.7.7,0,0,1,.7,0Z",
    transform: "translate(486.399 8830.988)",
    fill: "#1a1000"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_346",
    "data-name": "\\uC0AC\\uAC01\\uD615 346",
    width: 49.193,
    height: 32.995,
    rx: 1.865,
    transform: "translate(482.167 8832.131)",
    fill: "#ffb700"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1309",
    "data-name": "\\uADF8\\uB8F9 1309"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1304",
    "data-name": "\\uADF8\\uB8F9 1304"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_347",
    "data-name": "\\uC0AC\\uAC01\\uD615 347",
    width: 16.692,
    height: 0.676,
    transform: "translate(489.659 8838.267)",
    fill: "#804e00"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1305",
    "data-name": "\\uADF8\\uB8F9 1305"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_348",
    "data-name": "\\uC0AC\\uAC01\\uD615 348",
    width: 16.692,
    height: 0.676,
    transform: "translate(489.659 8840.148)",
    fill: "#804e00"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1306",
    "data-name": "\\uADF8\\uB8F9 1306"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_349",
    "data-name": "\\uC0AC\\uAC01\\uD615 349",
    width: 16.692,
    height: 0.676,
    transform: "translate(489.659 8842.031)",
    fill: "#804e00"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1307",
    "data-name": "\\uADF8\\uB8F9 1307"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_350",
    "data-name": "\\uC0AC\\uAC01\\uD615 350",
    width: 16.692,
    height: 0.676,
    transform: "translate(489.659 8843.913)",
    fill: "#804e00"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1308",
    "data-name": "\\uADF8\\uB8F9 1308"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_351",
    "data-name": "\\uC0AC\\uAC01\\uD615 351",
    width: 16.692,
    height: 0.676,
    transform: "translate(489.659 8845.795)",
    fill: "#804e00"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "\\uC0AC\\uAC01\\uD615_352",
    "data-name": "\\uC0AC\\uAC01\\uD615 352",
    d: "M.4,0H3.53a.4.4,0,0,1,.4.4v.49a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V.4A.4.4,0,0,1,.4,0Z",
    transform: "translate(519.161 8831.243)",
    fill: "#1a1000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uC0AC\\uAC01\\uD615_353",
    "data-name": "\\uC0AC\\uAC01\\uD615 353",
    d: "M.7,0H6.2a.7.7,0,0,1,.7.7v.583a.278.278,0,0,1-.278.278H.278A.278.278,0,0,1,0,1.282V.7A.7.7,0,0,1,.7,0Z",
    transform: "translate(517.674 8830.128)",
    fill: "#1a1000"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1310",
    "data-name": "\\uADF8\\uB8F9 1310"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2680",
    "data-name": "\\uD328\\uC2A4 2680",
    d: "M531.36,8857.911h0a2.724,2.724,0,0,1-2.724-2.725V8842.07a2.724,2.724,0,0,1,2.724-2.725h0Z",
    fill: "#1a1000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2681",
    "data-name": "\\uD328\\uC2A4 2681",
    d: "M529.414,8855.187V8842.07a2.724,2.724,0,0,1,1.946-2.61v-.114a2.724,2.724,0,0,0-2.724,2.725v13.116a2.724,2.724,0,0,0,2.724,2.725v-.115A2.723,2.723,0,0,1,529.414,8855.187Z",
    fill: "#303030"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1311",
    "data-name": "\\uADF8\\uB8F9 1311"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2682",
    "data-name": "\\uD328\\uC2A4 2682",
    d: "M482.167,8857.911h0a2.724,2.724,0,0,0,2.723-2.725V8842.07a2.724,2.724,0,0,0-2.723-2.725h0Z",
    fill: "#1a1000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2683",
    "data-name": "\\uD328\\uC2A4 2683",
    d: "M484.112,8855.187V8842.07a2.725,2.725,0,0,0-1.945-2.61v-.114a2.724,2.724,0,0,1,2.723,2.725v13.116a2.724,2.724,0,0,1-2.723,2.725v-.115A2.724,2.724,0,0,0,484.112,8855.187Z",
    fill: "#303030"
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2684",
    "data-name": "\\uD328\\uC2A4 2684",
    d: "M485.8,8862.34a.914.914,0,1,1-.915-.914A.915.915,0,0,1,485.8,8862.34Z",
    fill: "#e68d00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2685",
    "data-name": "\\uD328\\uC2A4 2685",
    d: "M527.721,8862.34a.915.915,0,1,0,.915-.914A.916.916,0,0,0,527.721,8862.34Z",
    fill: "#e68d00"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_354",
    "data-name": "\\uC0AC\\uAC01\\uD615 354",
    width: 16.5,
    height: 5.764,
    transform: "translate(489.851 8849.854)",
    fill: "#e68d00"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1313",
    "data-name": "\\uADF8\\uB8F9 1313"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2686",
    "data-name": "\\uD328\\uC2A4 2686",
    d: "M492.684,8855a.76.76,0,0,1-.714-.51,1.958,1.958,0,0,1-.184-3.469v-.117a.423.423,0,0,1,.422-.423h1.153a.423.423,0,0,1,.422.423v.117a1.958,1.958,0,0,1-.184,3.469.761.761,0,0,1-.714.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2687",
    "data-name": "\\uD328\\uC2A4 2687",
    d: "M494.431,8852.7a1.647,1.647,0,0,0-.962-1.5v-.307a.108.108,0,0,0-.108-.108h-1.153a.108.108,0,0,0-.108.108v.307a1.645,1.645,0,0,0,.136,3.048l.017.079a.44.44,0,0,0,.431.348h.2a.44.44,0,0,0,.431-.348l.016-.079A1.645,1.645,0,0,0,494.431,8852.7Z",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1312",
    "data-name": "\\uADF8\\uB8F9 1312"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2688",
    "data-name": "\\uD328\\uC2A4 2688",
    d: "M491.474,8852.96a.158.158,0,0,1-.157-.158,1.524,1.524,0,0,1,1.522-1.521.157.157,0,1,1,0,.313,1.209,1.209,0,0,0-1.208,1.208A.158.158,0,0,1,491.474,8852.96Z",
    fill: "#595959"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1316",
    "data-name": "\\uADF8\\uB8F9 1316"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1314",
    "data-name": "\\uADF8\\uB8F9 1314"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2689",
    "data-name": "\\uD328\\uC2A4 2689",
    d: "M496.36,8852.5a.418.418,0,1,1,0-.837h1.1a.418.418,0,1,1,0,.837Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2690",
    "data-name": "\\uD328\\uC2A4 2690",
    d: "M497.461,8852.335h-1.1a.25.25,0,0,1-.25-.249h0a.25.25,0,0,1,.25-.25h1.1a.25.25,0,0,1,.25.25h0A.25.25,0,0,1,497.461,8852.335Z",
    fill: "#ff4b15"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1315",
    "data-name": "\\uADF8\\uB8F9 1315"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2691",
    "data-name": "\\uD328\\uC2A4 2691",
    d: "M496.36,8853.8a.418.418,0,1,1,0-.837h1.1a.418.418,0,1,1,0,.837Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2692",
    "data-name": "\\uD328\\uC2A4 2692",
    d: "M497.461,8853.636h-1.1a.25.25,0,0,1-.25-.25h0a.249.249,0,0,1,.25-.249h1.1a.249.249,0,0,1,.25.249h0A.25.25,0,0,1,497.461,8853.636Z",
    fill: "#108c0b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1318",
    "data-name": "\\uADF8\\uB8F9 1318"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_355",
    "data-name": "\\uC0AC\\uAC01\\uD615 355",
    width: 6.202,
    height: 2.965,
    transform: "translate(499.075 8851.253)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1317",
    "data-name": "\\uADF8\\uB8F9 1317"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2693",
    "data-name": "\\uD328\\uC2A4 2693",
    d: "M500.06,8852.079h.184v.552h-.184Zm0,.739h.184v.552h-.184Zm.185-.925h.553v.184h-.553Zm0,.739h.553v.184h-.553Zm0,.739h.553v.183h-.553Zm.554-1.293h.184v.552H500.8Zm0,.739h.184v.552H500.8Z",
    fill: "#108c0b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2694",
    "data-name": "\\uD328\\uC2A4 2694",
    d: "M501.169,8851.894h.922v.184h-.738v.371h.554v.183h-.553v.186h-.183Zm0,1.293h.183v.184h-.183Zm.184.186h.553v.183h-.553Zm.555-.739h.183v.737h-.183Z",
    fill: "#108c0b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2695",
    "data-name": "\\uD328\\uC2A4 2695",
    d: "M502.277,8852.448h.183v.183h-.183Zm0,.924h.183v.183h-.183Z",
    fill: "#108c0b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2696",
    "data-name": "\\uD328\\uC2A4 2696",
    d: "M502.646,8852.079h.184v1.291h-.184Zm.185-.186h.553v.184h-.553Zm0,1.479h.553v.183h-.553Zm.554-1.293h.184v1.291h-.184Z",
    fill: "#108c0b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2697",
    "data-name": "\\uD328\\uC2A4 2697",
    d: "M504.124,8852.262h-.369v-.183l.369,0v-.184h.183v1.661h-.183Z",
    fill: "#108c0b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1319",
    "data-name": "\\uADF8\\uB8F9 1319"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_356",
    "data-name": "\\uC0AC\\uAC01\\uD615 356",
    width: 34.878,
    height: 0.676,
    transform: "translate(489.324 8862.002)",
    fill: "#f78a34"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1326",
    "data-name": "\\uADF8\\uB8F9 1326"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1320",
    "data-name": "\\uADF8\\uB8F9 1320"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_357",
    "data-name": "\\uC0AC\\uAC01\\uD615 357",
    width: 0.676,
    height: 7.119,
    transform: "translate(510.734 8852.736)",
    fill: "#f78a34"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1321",
    "data-name": "\\uADF8\\uB8F9 1321"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_358",
    "data-name": "\\uC0AC\\uAC01\\uD615 358",
    width: 0.676,
    height: 7.119,
    transform: "translate(513.302 8852.736)",
    fill: "#f78a34"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1322",
    "data-name": "\\uADF8\\uB8F9 1322"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_359",
    "data-name": "\\uC0AC\\uAC01\\uD615 359",
    width: 0.676,
    height: 7.119,
    transform: "translate(515.871 8852.736)",
    fill: "#f78a34"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1323",
    "data-name": "\\uADF8\\uB8F9 1323"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_360",
    "data-name": "\\uC0AC\\uAC01\\uD615 360",
    width: 0.676,
    height: 7.119,
    transform: "translate(518.44 8852.736)",
    fill: "#f78a34"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1324",
    "data-name": "\\uADF8\\uB8F9 1324"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_361",
    "data-name": "\\uC0AC\\uAC01\\uD615 361",
    width: 0.676,
    height: 7.119,
    transform: "translate(521.009 8852.736)",
    fill: "#f78a34"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1325",
    "data-name": "\\uADF8\\uB8F9 1325"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_362",
    "data-name": "\\uC0AC\\uAC01\\uD615 362",
    width: 0.676,
    height: 7.119,
    transform: "translate(523.578 8852.736)",
    fill: "#f78a34"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_363",
    "data-name": "\\uC0AC\\uAC01\\uD615 363",
    width: 16.5,
    height: 1.645,
    rx: 0.631,
    transform: "translate(489.851 8858.21)",
    fill: "#303030"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_364",
    "data-name": "\\uC0AC\\uAC01\\uD615 364",
    width: 25.896,
    height: 0.496,
    transform: "translate(493.89 8865.126)",
    fill: "#f78a34"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uC0AC\\uAC01\\uD615_365",
    "data-name": "\\uC0AC\\uAC01\\uD615 365",
    d: "M.7,0H6.2a.7.7,0,0,1,.7.7v.583a.278.278,0,0,1-.278.278H.278A.278.278,0,0,1,0,1.282V.7A.7.7,0,0,1,.7,0Z",
    transform: "translate(487.686 8865.126)",
    fill: "#1a1000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uC0AC\\uAC01\\uD615_366",
    "data-name": "\\uC0AC\\uAC01\\uD615 366",
    d: "M.278,0H6.625A.278.278,0,0,1,6.9.278V.861a.7.7,0,0,1-.7.7H.7a.7.7,0,0,1-.7-.7V.278A.278.278,0,0,1,.278,0Z",
    transform: "translate(525.84 8866.686) rotate(180)",
    fill: "#1a1000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2698",
    "data-name": "\\uD328\\uC2A4 2698",
    d: "M506.763,8835.831a183.568,183.568,0,0,1,24.6,1.571V8834a1.865,1.865,0,0,0-1.865-1.864H484.031a1.864,1.864,0,0,0-1.864,1.864v3.407A183.553,183.553,0,0,1,506.763,8835.831Z",
    fill: "#ffc305"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1328",
    "data-name": "\\uADF8\\uB8F9 1328"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1327",
    "data-name": "\\uADF8\\uB8F9 1327"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2699",
    "data-name": "\\uD328\\uC2A4 2699",
    d: "M520.649,8835.054h-3.29l-2.847,7.3,1.33.023,1.047.019-3.264,5.668,6.042-6.157,1.833-1.832-3.5.046Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2700",
    "data-name": "\\uD328\\uC2A4 2700",
    d: "M520.542,8836.871l-.348.664a5.358,5.358,0,0,1-2.81,9.921,5.308,5.308,0,0,1-1.806-.314l-.57.581a6.106,6.106,0,0,0,5.534-10.852Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2701",
    "data-name": "\\uD328\\uC2A4 2701",
    d: "M513.489,8846.8l.379-.658a5.359,5.359,0,0,1,1.939-9.167l.335-.858a6.107,6.107,0,0,0-2.653,10.684Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2702",
    "data-name": "\\uD328\\uC2A4 2702",
    d: "M485.8,8834.916a.914.914,0,1,0-.915.915A.914.914,0,0,0,485.8,8834.916Z",
    fill: "#e68d00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2703",
    "data-name": "\\uD328\\uC2A4 2703",
    d: "M527.721,8834.916a.915.915,0,1,1,.915.915A.915.915,0,0,1,527.721,8834.916Z",
    fill: "#e68d00"
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2704",
    "data-name": "\\uD328\\uC2A4 2704",
    d: "M530.874,8867.656H482.652a.485.485,0,0,1-.485-.485h0a.486.486,0,0,1,.485-.486h48.222a.487.487,0,0,1,.486.486h0A.486.486,0,0,1,530.874,8867.656Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1339",
    "data-name": "\\uADF8\\uB8F9 1339",
    transform: "translate(-276.197 -8671.303)"
  }, _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_367",
    "data-name": "\\uC0AC\\uAC01\\uD615 367",
    width: 4.184,
    height: 0.915,
    transform: "translate(416.848 8831.996)",
    fill: "#29333f"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_368",
    "data-name": "\\uC0AC\\uAC01\\uD615 368",
    width: 4.184,
    height: 0.915,
    transform: "translate(423.2 8831.996)",
    fill: "#29333f"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_369",
    "data-name": "\\uC0AC\\uAC01\\uD615 369",
    width: 4.184,
    height: 0.915,
    transform: "translate(429.552 8831.996)",
    fill: "#29333f"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_370",
    "data-name": "\\uC0AC\\uAC01\\uD615 370",
    width: 4.184,
    height: 0.915,
    transform: "translate(435.905 8831.996)",
    fill: "#29333f"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_371",
    "data-name": "\\uC0AC\\uAC01\\uD615 371",
    width: 4.184,
    height: 0.915,
    transform: "translate(442.257 8831.996)",
    fill: "#29333f"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_372",
    "data-name": "\\uC0AC\\uAC01\\uD615 372",
    width: 4.184,
    height: 0.915,
    transform: "translate(448.61 8831.996)",
    fill: "#29333f"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_373",
    "data-name": "\\uC0AC\\uAC01\\uD615 373",
    width: 43.393,
    height: 4.814,
    transform: "translate(413.361 8832.911)",
    fill: "#414e5f"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_374",
    "data-name": "\\uC0AC\\uAC01\\uD615 374",
    width: 23.399,
    height: 4.814,
    transform: "translate(423.342 8832.911)",
    fill: "#414e5f"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_375",
    "data-name": "\\uC0AC\\uAC01\\uD615 375",
    width: 0.979,
    height: 4.814,
    transform: "translate(423.342 8832.911)",
    fill: "#29333f",
    opacity: 0.5
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_376",
    "data-name": "\\uC0AC\\uAC01\\uD615 376",
    width: 0.979,
    height: 4.814,
    transform: "translate(445.762 8832.911)",
    fill: "#5b6879",
    opacity: 0.5
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_377",
    "data-name": "\\uC0AC\\uAC01\\uD615 377",
    width: 0.979,
    height: 4.814,
    transform: "translate(455.776 8832.911)",
    fill: "#5b6879",
    opacity: 0.5
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_378",
    "data-name": "\\uC0AC\\uAC01\\uD615 378",
    width: 0.979,
    height: 4.814,
    transform: "translate(413.361 8832.911)",
    fill: "#29333f",
    opacity: 0.5
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_379",
    "data-name": "\\uC0AC\\uAC01\\uD615 379",
    width: 47.025,
    height: 3.133,
    transform: "translate(411.546 8837.726)",
    fill: "#414e5f"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_380",
    "data-name": "\\uC0AC\\uAC01\\uD615 380",
    width: 1.443,
    height: 3.133,
    transform: "translate(411.546 8837.726)",
    fill: "#29333f",
    opacity: 0.5
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_381",
    "data-name": "\\uC0AC\\uAC01\\uD615 381",
    width: 1.443,
    height: 3.133,
    transform: "translate(457.128 8837.726)",
    fill: "#5b6879",
    opacity: 0.5
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1331",
    "data-name": "\\uADF8\\uB8F9 1331"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_382",
    "data-name": "\\uC0AC\\uAC01\\uD615 382",
    width: 45.396,
    height: 23.27,
    transform: "translate(412.507 8840.857)",
    fill: "#3b78e2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_383",
    "data-name": "\\uC0AC\\uAC01\\uD615 383",
    width: 1.202,
    height: 23.27,
    transform: "translate(412.507 8840.857)",
    fill: "#bebcb7",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_384",
    "data-name": "\\uC0AC\\uAC01\\uD615 384",
    width: 1.202,
    height: 23.27,
    transform: "translate(456.7 8840.857)",
    fill: "#fefcf7",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_385",
    "data-name": "\\uC0AC\\uAC01\\uD615 385",
    width: 45.396,
    height: 0.482,
    transform: "translate(412.507 8863.646)",
    fill: "#bebcb7"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1338",
    "data-name": "\\uADF8\\uB8F9 1338"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1332",
    "data-name": "\\uADF8\\uB8F9 1332"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_386",
    "data-name": "\\uC0AC\\uAC01\\uD615 386",
    width: 2.682,
    height: 17.35,
    transform: "translate(417.959 8844.256)",
    fill: "#bebcb7",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_387",
    "data-name": "\\uC0AC\\uAC01\\uD615 387",
    width: 2.682,
    height: 0.503,
    transform: "translate(417.959 8844.256)",
    fill: "#bebcb7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_388",
    "data-name": "\\uC0AC\\uAC01\\uD615 388",
    width: 2.682,
    height: 0.415,
    transform: "translate(417.959 8861.189)",
    fill: "#fefcf7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1333",
    "data-name": "\\uADF8\\uB8F9 1333"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_389",
    "data-name": "\\uC0AC\\uAC01\\uD615 389",
    width: 2.682,
    height: 17.35,
    transform: "translate(424.321 8844.256)",
    fill: "#bebcb7",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_390",
    "data-name": "\\uC0AC\\uAC01\\uD615 390",
    width: 2.682,
    height: 0.503,
    transform: "translate(424.321 8844.256)",
    fill: "#bebcb7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_391",
    "data-name": "\\uC0AC\\uAC01\\uD615 391",
    width: 2.682,
    height: 0.415,
    transform: "translate(424.321 8861.189)",
    fill: "#fefcf7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1334",
    "data-name": "\\uADF8\\uB8F9 1334"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_392",
    "data-name": "\\uC0AC\\uAC01\\uD615 392",
    width: 2.682,
    height: 17.35,
    transform: "translate(430.683 8844.256)",
    fill: "#bebcb7",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_393",
    "data-name": "\\uC0AC\\uAC01\\uD615 393",
    width: 2.682,
    height: 0.503,
    transform: "translate(430.683 8844.256)",
    fill: "#bebcb7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_394",
    "data-name": "\\uC0AC\\uAC01\\uD615 394",
    width: 2.682,
    height: 0.415,
    transform: "translate(430.683 8861.189)",
    fill: "#fefcf7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1335",
    "data-name": "\\uADF8\\uB8F9 1335"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_395",
    "data-name": "\\uC0AC\\uAC01\\uD615 395",
    width: 2.682,
    height: 17.35,
    transform: "translate(437.045 8844.256)",
    fill: "#bebcb7",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_396",
    "data-name": "\\uC0AC\\uAC01\\uD615 396",
    width: 2.682,
    height: 0.503,
    transform: "translate(437.045 8844.256)",
    fill: "#bebcb7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_397",
    "data-name": "\\uC0AC\\uAC01\\uD615 397",
    width: 2.682,
    height: 0.415,
    transform: "translate(437.045 8861.189)",
    fill: "#fefcf7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1336",
    "data-name": "\\uADF8\\uB8F9 1336"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_398",
    "data-name": "\\uC0AC\\uAC01\\uD615 398",
    width: 2.682,
    height: 17.35,
    transform: "translate(443.406 8844.256)",
    fill: "#bebcb7",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_399",
    "data-name": "\\uC0AC\\uAC01\\uD615 399",
    width: 2.682,
    height: 0.503,
    transform: "translate(443.406 8844.256)",
    fill: "#bebcb7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_400",
    "data-name": "\\uC0AC\\uAC01\\uD615 400",
    width: 2.682,
    height: 0.415,
    transform: "translate(443.406 8861.189)",
    fill: "#fefcf7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1337",
    "data-name": "\\uADF8\\uB8F9 1337"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_401",
    "data-name": "\\uC0AC\\uAC01\\uD615 401",
    width: 2.682,
    height: 17.35,
    transform: "translate(449.768 8844.256)",
    fill: "#bebcb7",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_402",
    "data-name": "\\uC0AC\\uAC01\\uD615 402",
    width: 2.682,
    height: 0.503,
    transform: "translate(449.768 8844.256)",
    fill: "#bebcb7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_403",
    "data-name": "\\uC0AC\\uAC01\\uD615 403",
    width: 2.682,
    height: 0.415,
    transform: "translate(449.768 8861.189)",
    fill: "#fefcf7"
  })))), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_404",
    "data-name": "\\uC0AC\\uAC01\\uD615 404",
    width: 47.025,
    height: 0.21,
    transform: "translate(411.546 8837.726)",
    fill: "#5b6879"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_405",
    "data-name": "\\uC0AC\\uAC01\\uD615 405",
    width: 45.396,
    height: 1.076,
    transform: "translate(412.507 8840.857)",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_406",
    "data-name": "\\uC0AC\\uAC01\\uD615 406",
    width: 43.393,
    height: 0.267,
    transform: "translate(413.361 8832.911)",
    fill: "#5b6879"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_407",
    "data-name": "\\uC0AC\\uAC01\\uD615 407",
    width: 17.994,
    height: 0.723,
    transform: "translate(425.936 8832.188)",
    fill: "#414e5f"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1350",
    "data-name": "\\uADF8\\uB8F9 1350",
    transform: "translate(-276.197 -8671.303)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_408",
    "data-name": "\\uC0AC\\uAC01\\uD615 408",
    width: 57.867,
    height: 82.387,
    transform: "translate(488.205 8984.307)",
    fill: "#dddbd6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_409",
    "data-name": "\\uC0AC\\uAC01\\uD615 409",
    width: 57.867,
    height: 2.37,
    transform: "translate(488.205 8984.307)",
    fill: "#fefcf7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_410",
    "data-name": "\\uC0AC\\uAC01\\uD615 410",
    width: 21.98,
    height: 17.486,
    transform: "translate(506.573 8997.79)",
    fill: "#414e5f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_411",
    "data-name": "\\uC0AC\\uAC01\\uD615 411",
    width: 21.98,
    height: 0.334,
    transform: "translate(506.573 8997.79)",
    fill: "#bebcb7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_412",
    "data-name": "\\uC0AC\\uAC01\\uD615 412",
    width: 21.98,
    height: 0.334,
    transform: "translate(506.573 9014.942)",
    fill: "#fefcf7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_413",
    "data-name": "\\uC0AC\\uAC01\\uD615 413",
    width: 13.714,
    height: 6.915,
    transform: "translate(510.847 9000.915)",
    fill: "#58625b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_414",
    "data-name": "\\uC0AC\\uAC01\\uD615 414",
    width: 13.306,
    height: 6.507,
    transform: "translate(511.052 9001.119)",
    fill: "#7e8881"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_415",
    "data-name": "\\uC0AC\\uAC01\\uD615 415",
    width: 57.867,
    height: 9.613,
    transform: "translate(488.205 9066.693)",
    fill: "#29333f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_416",
    "data-name": "\\uC0AC\\uAC01\\uD615 416",
    width: 57.867,
    height: 2.515,
    transform: "translate(488.205 9066.693)",
    fill: "#414e5f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_417",
    "data-name": "\\uC0AC\\uAC01\\uD615 417",
    width: 1.784,
    height: 56.998,
    transform: "translate(546.071 8992.283)",
    fill: "#414e5f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_418",
    "data-name": "\\uC0AC\\uAC01\\uD615 418",
    width: 1.784,
    height: 56.998,
    transform: "translate(486.421 8992.283)",
    fill: "#414e5f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1341",
    "data-name": "\\uADF8\\uB8F9 1341"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1340",
    "data-name": "\\uADF8\\uB8F9 1340"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2705",
    "data-name": "\\uD328\\uC2A4 2705",
    d: "M514.837,9003.184h-.894l-.105.105.105.105h.894l.106-.105Z",
    fill: "#414e52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2706",
    "data-name": "\\uD328\\uC2A4 2706",
    d: "M514.837,9002.007h-.894l-.105.105.105.105h.894l.106-.105Z",
    fill: "#414e52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2707",
    "data-name": "\\uD328\\uC2A4 2707",
    d: "M514.837,9004.359h-.894l-.105.106.105.1h.894l.106-.1Z",
    fill: "#414e52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2708",
    "data-name": "\\uD328\\uC2A4 2708",
    d: "M513.8,9002.148l-.1.105v.894l.1.105.106-.105v-.894Z",
    fill: "#414e52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2709",
    "data-name": "\\uD328\\uC2A4 2709",
    d: "M514.978,9002.148l-.105.105v.894l.105.105.105-.105v-.894Z",
    fill: "#414e52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2710",
    "data-name": "\\uD328\\uC2A4 2710",
    d: "M513.8,9003.325l-.1.105v.894l.1.105.106-.105v-.894Z",
    fill: "#414e52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2711",
    "data-name": "\\uD328\\uC2A4 2711",
    d: "M514.978,9003.325l-.105.105v.894l.105.105.105-.105v-.894Z",
    fill: "#414e52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2712",
    "data-name": "\\uD328\\uC2A4 2712",
    d: "M513.138,9003.184h-.893l-.1.105.1.105h.893l.106-.105Z",
    fill: "#414e52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2713",
    "data-name": "\\uD328\\uC2A4 2713",
    d: "M513.138,9002.007h-.893l-.1.105.1.105h.893l.106-.105Z",
    fill: "#414e52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2714",
    "data-name": "\\uD328\\uC2A4 2714",
    d: "M513.138,9004.359h-.893l-.1.106.1.1h.893l.106-.1Z",
    fill: "#414e52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2715",
    "data-name": "\\uD328\\uC2A4 2715",
    d: "M512.1,9002.148l-.106.105v.894l.106.105.1-.105v-.894Z",
    fill: "#414e52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2716",
    "data-name": "\\uD328\\uC2A4 2716",
    d: "M513.279,9002.148l-.106.105v.894l.106.105.106-.105v-.894Z",
    fill: "#414e52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2717",
    "data-name": "\\uD328\\uC2A4 2717",
    d: "M512.1,9003.325l-.106.105v.894l.106.105.1-.105v-.894Z",
    fill: "#414e52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2718",
    "data-name": "\\uD328\\uC2A4 2718",
    d: "M513.279,9003.325l-.106.105v.894l.106.105.106-.105v-.894Z",
    fill: "#414e52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2719",
    "data-name": "\\uD328\\uC2A4 2719",
    d: "M518.827,9003.184h-.893l-.106.105.106.105h.893l.105-.105Z",
    fill: "#414e52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2720",
    "data-name": "\\uD328\\uC2A4 2720",
    d: "M518.827,9002.007h-.893l-.106.105.106.105h.893l.105-.105Z",
    fill: "#414e52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2721",
    "data-name": "\\uD328\\uC2A4 2721",
    d: "M518.827,9004.359h-.893l-.106.106.106.1h.893l.105-.1Z",
    fill: "#414e52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2722",
    "data-name": "\\uD328\\uC2A4 2722",
    d: "M517.792,9002.148l-.106.105v.894l.106.105.106-.105v-.894Z",
    fill: "#414e52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2723",
    "data-name": "\\uD328\\uC2A4 2723",
    d: "M518.968,9002.148l-.106.105v.894l.106.105.105-.105v-.894Z",
    fill: "#414e52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2724",
    "data-name": "\\uD328\\uC2A4 2724",
    d: "M517.792,9003.325l-.106.105v.894l.106.105.106-.105v-.894Z",
    fill: "#414e52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2725",
    "data-name": "\\uD328\\uC2A4 2725",
    d: "M518.968,9003.325l-.106.105v.894l.106.105.105-.105v-.894Z",
    fill: "#414e52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2726",
    "data-name": "\\uD328\\uC2A4 2726",
    d: "M517.127,9003.184h-.893l-.106.105.106.105h.893l.106-.105Z",
    fill: "#414e52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2727",
    "data-name": "\\uD328\\uC2A4 2727",
    d: "M517.127,9002.007h-.893l-.106.105.106.105h.893l.106-.105Z",
    fill: "#414e52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2728",
    "data-name": "\\uD328\\uC2A4 2728",
    d: "M517.127,9004.359h-.893l-.106.106.106.1h.893l.106-.1Z",
    fill: "#414e52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2729",
    "data-name": "\\uD328\\uC2A4 2729",
    d: "M516.093,9002.148l-.106.105v.894l.106.105.1-.105v-.894Z",
    fill: "#414e52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2730",
    "data-name": "\\uD328\\uC2A4 2730",
    d: "M517.269,9002.148l-.106.105v.894l.106.105.105-.105v-.894Z",
    fill: "#414e52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2731",
    "data-name": "\\uD328\\uC2A4 2731",
    d: "M516.093,9003.325l-.106.105v.894l.106.105.1-.105v-.894Z",
    fill: "#414e52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2732",
    "data-name": "\\uD328\\uC2A4 2732",
    d: "M517.269,9003.325l-.106.105v.894l.106.105.105-.105v-.894Z",
    fill: "#414e52"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_419",
    "data-name": "\\uC0AC\\uAC01\\uD615 419",
    width: 0.21,
    height: 0.21,
    transform: "translate(515.435 9004.359)",
    fill: "#414e52"
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2733",
    "data-name": "\\uD328\\uC2A4 2733",
    d: "M522.814,9003.184h-.893l-.106.105.106.105h.893l.105-.105Z",
    fill: "#414e52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2734",
    "data-name": "\\uD328\\uC2A4 2734",
    d: "M522.814,9002.007h-.893l-.106.105.106.105h.893l.105-.105Z",
    fill: "#414e52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2735",
    "data-name": "\\uD328\\uC2A4 2735",
    d: "M522.814,9004.359h-.893l-.106.106.106.1h.893l.105-.1Z",
    fill: "#414e52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2736",
    "data-name": "\\uD328\\uC2A4 2736",
    d: "M521.779,9002.148l-.105.105v.894l.105.105.106-.105v-.894Z",
    fill: "#414e52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2737",
    "data-name": "\\uD328\\uC2A4 2737",
    d: "M522.956,9002.148l-.106.105v.894l.106.105.106-.105v-.894Z",
    fill: "#414e52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2738",
    "data-name": "\\uD328\\uC2A4 2738",
    d: "M521.779,9003.325l-.105.105v.894l.105.105.106-.105v-.894Z",
    fill: "#414e52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2739",
    "data-name": "\\uD328\\uC2A4 2739",
    d: "M522.956,9003.325l-.106.105v.894l.106.105.106-.105v-.894Z",
    fill: "#414e52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2740",
    "data-name": "\\uD328\\uC2A4 2740",
    d: "M521.116,9003.184h-.894l-.105.105.105.105h.894l.1-.105Z",
    fill: "#414e52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2741",
    "data-name": "\\uD328\\uC2A4 2741",
    d: "M521.116,9002.007h-.894l-.105.105.105.105h.894l.1-.105Z",
    fill: "#414e52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2742",
    "data-name": "\\uD328\\uC2A4 2742",
    d: "M521.116,9004.359h-.894l-.105.106.105.1h.894l.1-.1Z",
    fill: "#414e52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2743",
    "data-name": "\\uD328\\uC2A4 2743",
    d: "M520.081,9002.148l-.106.105v.894l.106.105.1-.105v-.894Z",
    fill: "#414e52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2744",
    "data-name": "\\uD328\\uC2A4 2744",
    d: "M521.257,9002.148l-.106.105v.894l.106.105.105-.105v-.894Z",
    fill: "#414e52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2745",
    "data-name": "\\uD328\\uC2A4 2745",
    d: "M520.081,9003.325l-.106.105v.894l.106.105.1-.105v-.894Z",
    fill: "#414e52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2746",
    "data-name": "\\uD328\\uC2A4 2746",
    d: "M521.257,9003.325l-.106.105v.894l.106.105.105-.105v-.894Z",
    fill: "#414e52"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1342",
    "data-name": "\\uADF8\\uB8F9 1342"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2747",
    "data-name": "\\uD328\\uC2A4 2747",
    d: "M512.157,9012.523a1.354,1.354,0,1,1,1.354-1.355A1.357,1.357,0,0,1,512.157,9012.523Zm0-2.619a1.264,1.264,0,1,0,1.264,1.264A1.266,1.266,0,0,0,512.157,9009.9Z",
    fill: "#d4dbdf"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1343",
    "data-name": "\\uADF8\\uB8F9 1343"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2748",
    "data-name": "\\uD328\\uC2A4 2748",
    d: "M515.865,9012.523a1.354,1.354,0,1,1,1.354-1.355A1.356,1.356,0,0,1,515.865,9012.523Zm0-2.619a1.264,1.264,0,1,0,1.264,1.264A1.265,1.265,0,0,0,515.865,9009.9Z",
    fill: "#d4dbdf"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1344",
    "data-name": "\\uADF8\\uB8F9 1344"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2749",
    "data-name": "\\uD328\\uC2A4 2749",
    d: "M519.572,9012.523a1.354,1.354,0,1,1,1.355-1.355A1.357,1.357,0,0,1,519.572,9012.523Zm0-2.619a1.264,1.264,0,1,0,1.265,1.264A1.266,1.266,0,0,0,519.572,9009.9Z",
    fill: "#d4dbdf"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1345",
    "data-name": "\\uADF8\\uB8F9 1345"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2750",
    "data-name": "\\uD328\\uC2A4 2750",
    d: "M523.279,9012.523a1.354,1.354,0,1,1,1.356-1.355A1.357,1.357,0,0,1,523.279,9012.523Zm0-2.619a1.264,1.264,0,1,0,1.265,1.264A1.265,1.265,0,0,0,523.279,9009.9Z",
    fill: "#d4dbdf"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1346",
    "data-name": "\\uADF8\\uB8F9 1346"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2751",
    "data-name": "\\uD328\\uC2A4 2751",
    d: "M509.608,9002.64a.633.633,0,1,1-.633-.633A.634.634,0,0,1,509.608,9002.64Z",
    fill: "#29333f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2752",
    "data-name": "\\uD328\\uC2A4 2752",
    d: "M509.518,9002.64a.543.543,0,1,1-.543-.543A.543.543,0,0,1,509.518,9002.64Z",
    fill: "red",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2753",
    "data-name": "\\uD328\\uC2A4 2753",
    d: "M509.382,9002.64a.407.407,0,1,1-.407-.406A.407.407,0,0,1,509.382,9002.64Z",
    fill: "red",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2754",
    "data-name": "\\uD328\\uC2A4 2754",
    d: "M509.273,9002.64a.3.3,0,1,1-.3-.3A.3.3,0,0,1,509.273,9002.64Z",
    fill: "red"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1347",
    "data-name": "\\uADF8\\uB8F9 1347"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2755",
    "data-name": "\\uD328\\uC2A4 2755",
    d: "M509.608,9005.76a.633.633,0,1,1-.633-.633A.633.633,0,0,1,509.608,9005.76Z",
    fill: "#29333f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2756",
    "data-name": "\\uD328\\uC2A4 2756",
    d: "M509.518,9005.76a.543.543,0,1,1-.543-.542A.544.544,0,0,1,509.518,9005.76Z",
    fill: "lime",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2757",
    "data-name": "\\uD328\\uC2A4 2757",
    d: "M509.382,9005.76a.407.407,0,1,1-.407-.407A.407.407,0,0,1,509.382,9005.76Z",
    fill: "lime",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2758",
    "data-name": "\\uD328\\uC2A4 2758",
    d: "M509.273,9005.76a.3.3,0,1,1-.3-.3A.3.3,0,0,1,509.273,9005.76Z",
    fill: "lime"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1348",
    "data-name": "\\uADF8\\uB8F9 1348"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2759",
    "data-name": "\\uD328\\uC2A4 2759",
    d: "M526.919,9002.64a.633.633,0,1,1-.633-.633A.634.634,0,0,1,526.919,9002.64Z",
    fill: "#29333f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2760",
    "data-name": "\\uD328\\uC2A4 2760",
    d: "M526.829,9002.64a.543.543,0,1,1-.543-.543A.543.543,0,0,1,526.829,9002.64Z",
    fill: "lime",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2761",
    "data-name": "\\uD328\\uC2A4 2761",
    d: "M526.693,9002.64a.407.407,0,1,1-.407-.406A.407.407,0,0,1,526.693,9002.64Z",
    fill: "lime",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2762",
    "data-name": "\\uD328\\uC2A4 2762",
    d: "M526.584,9002.64a.3.3,0,1,1-.3-.3A.3.3,0,0,1,526.584,9002.64Z",
    fill: "lime"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1349",
    "data-name": "\\uADF8\\uB8F9 1349"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2763",
    "data-name": "\\uD328\\uC2A4 2763",
    d: "M526.919,9005.76a.633.633,0,1,1-.633-.633A.633.633,0,0,1,526.919,9005.76Z",
    fill: "#29333f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2764",
    "data-name": "\\uD328\\uC2A4 2764",
    d: "M526.829,9005.76a.543.543,0,1,1-.543-.542A.544.544,0,0,1,526.829,9005.76Z",
    fill: "lime",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2765",
    "data-name": "\\uD328\\uC2A4 2765",
    d: "M526.693,9005.76a.407.407,0,1,1-.407-.407A.407.407,0,0,1,526.693,9005.76Z",
    fill: "lime",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2766",
    "data-name": "\\uD328\\uC2A4 2766",
    d: "M526.584,9005.76a.3.3,0,1,1-.3-.3A.3.3,0,0,1,526.584,9005.76Z",
    fill: "lime"
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2767",
    "data-name": "\\uD328\\uC2A4 2767",
    d: "M512.891,9006.562a.394.394,0,1,1-.394-.395A.394.394,0,0,1,512.891,9006.562Z",
    fill: "#414e52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2768",
    "data-name": "\\uD328\\uC2A4 2768",
    d: "M514.232,9006.562a.394.394,0,1,1-.394-.395A.394.394,0,0,1,514.232,9006.562Z",
    fill: "#414e52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2769",
    "data-name": "\\uD328\\uC2A4 2769",
    d: "M523.156,9006.562a.394.394,0,1,1-.394-.395A.394.394,0,0,1,523.156,9006.562Z",
    fill: "#414e52"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1361",
    "data-name": "\\uADF8\\uB8F9 1361",
    transform: "translate(-276.197 -8671.303)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_420",
    "data-name": "\\uC0AC\\uAC01\\uD615 420",
    width: 57.867,
    height: 82.387,
    transform: "translate(572.205 8984.307)",
    fill: "#dddbd6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_421",
    "data-name": "\\uC0AC\\uAC01\\uD615 421",
    width: 57.867,
    height: 2.37,
    transform: "translate(572.205 8984.307)",
    fill: "#fefcf7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_422",
    "data-name": "\\uC0AC\\uAC01\\uD615 422",
    width: 21.98,
    height: 17.486,
    transform: "translate(590.573 8997.79)",
    fill: "#414e5f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_423",
    "data-name": "\\uC0AC\\uAC01\\uD615 423",
    width: 21.98,
    height: 0.334,
    transform: "translate(590.573 8997.79)",
    fill: "#bebcb7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_424",
    "data-name": "\\uC0AC\\uAC01\\uD615 424",
    width: 21.98,
    height: 0.334,
    transform: "translate(590.573 9014.942)",
    fill: "#fefcf7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_425",
    "data-name": "\\uC0AC\\uAC01\\uD615 425",
    width: 13.714,
    height: 6.915,
    transform: "translate(594.847 9000.915)",
    fill: "#58625b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_426",
    "data-name": "\\uC0AC\\uAC01\\uD615 426",
    width: 13.306,
    height: 6.507,
    transform: "translate(595.052 9001.119)",
    fill: "#7e8881"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_427",
    "data-name": "\\uC0AC\\uAC01\\uD615 427",
    width: 57.867,
    height: 9.613,
    transform: "translate(572.205 9066.693)",
    fill: "#29333f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_428",
    "data-name": "\\uC0AC\\uAC01\\uD615 428",
    width: 57.867,
    height: 2.515,
    transform: "translate(572.205 9066.693)",
    fill: "#414e5f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_429",
    "data-name": "\\uC0AC\\uAC01\\uD615 429",
    width: 1.784,
    height: 56.998,
    transform: "translate(630.071 8992.283)",
    fill: "#414e5f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_430",
    "data-name": "\\uC0AC\\uAC01\\uD615 430",
    width: 1.784,
    height: 56.998,
    transform: "translate(570.421 8992.283)",
    fill: "#414e5f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1352",
    "data-name": "\\uADF8\\uB8F9 1352"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1351",
    "data-name": "\\uADF8\\uB8F9 1351"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2770",
    "data-name": "\\uD328\\uC2A4 2770",
    d: "M598.837,9003.184h-.894l-.105.105.105.105h.894l.106-.105Z",
    fill: "#414e52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2771",
    "data-name": "\\uD328\\uC2A4 2771",
    d: "M598.837,9002.007h-.894l-.105.105.105.105h.894l.106-.105Z",
    fill: "#414e52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2772",
    "data-name": "\\uD328\\uC2A4 2772",
    d: "M598.837,9004.359h-.894l-.105.106.105.1h.894l.106-.1Z",
    fill: "#414e52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2773",
    "data-name": "\\uD328\\uC2A4 2773",
    d: "M597.8,9002.148l-.1.105v.894l.1.105.106-.105v-.894Z",
    fill: "#414e52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2774",
    "data-name": "\\uD328\\uC2A4 2774",
    d: "M598.978,9002.148l-.105.105v.894l.105.105.105-.105v-.894Z",
    fill: "#414e52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2775",
    "data-name": "\\uD328\\uC2A4 2775",
    d: "M597.8,9003.325l-.1.105v.894l.1.105.106-.105v-.894Z",
    fill: "#414e52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2776",
    "data-name": "\\uD328\\uC2A4 2776",
    d: "M598.978,9003.325l-.105.105v.894l.105.105.105-.105v-.894Z",
    fill: "#414e52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2777",
    "data-name": "\\uD328\\uC2A4 2777",
    d: "M597.138,9003.184h-.893l-.1.105.1.105h.893l.106-.105Z",
    fill: "#414e52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2778",
    "data-name": "\\uD328\\uC2A4 2778",
    d: "M597.138,9002.007h-.893l-.1.105.1.105h.893l.106-.105Z",
    fill: "#414e52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2779",
    "data-name": "\\uD328\\uC2A4 2779",
    d: "M597.138,9004.359h-.893l-.1.106.1.1h.893l.106-.1Z",
    fill: "#414e52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2780",
    "data-name": "\\uD328\\uC2A4 2780",
    d: "M596.1,9002.148l-.106.105v.894l.106.105.1-.105v-.894Z",
    fill: "#414e52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2781",
    "data-name": "\\uD328\\uC2A4 2781",
    d: "M597.279,9002.148l-.106.105v.894l.106.105.106-.105v-.894Z",
    fill: "#414e52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2782",
    "data-name": "\\uD328\\uC2A4 2782",
    d: "M596.1,9003.325l-.106.105v.894l.106.105.1-.105v-.894Z",
    fill: "#414e52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2783",
    "data-name": "\\uD328\\uC2A4 2783",
    d: "M597.279,9003.325l-.106.105v.894l.106.105.106-.105v-.894Z",
    fill: "#414e52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2784",
    "data-name": "\\uD328\\uC2A4 2784",
    d: "M602.827,9003.184h-.893l-.106.105.106.105h.893l.105-.105Z",
    fill: "#414e52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2785",
    "data-name": "\\uD328\\uC2A4 2785",
    d: "M602.827,9002.007h-.893l-.106.105.106.105h.893l.105-.105Z",
    fill: "#414e52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2786",
    "data-name": "\\uD328\\uC2A4 2786",
    d: "M602.827,9004.359h-.893l-.106.106.106.1h.893l.105-.1Z",
    fill: "#414e52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2787",
    "data-name": "\\uD328\\uC2A4 2787",
    d: "M601.792,9002.148l-.106.105v.894l.106.105.106-.105v-.894Z",
    fill: "#414e52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2788",
    "data-name": "\\uD328\\uC2A4 2788",
    d: "M602.968,9002.148l-.106.105v.894l.106.105.105-.105v-.894Z",
    fill: "#414e52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2789",
    "data-name": "\\uD328\\uC2A4 2789",
    d: "M601.792,9003.325l-.106.105v.894l.106.105.106-.105v-.894Z",
    fill: "#414e52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2790",
    "data-name": "\\uD328\\uC2A4 2790",
    d: "M602.968,9003.325l-.106.105v.894l.106.105.105-.105v-.894Z",
    fill: "#414e52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2791",
    "data-name": "\\uD328\\uC2A4 2791",
    d: "M601.127,9003.184h-.893l-.106.105.106.105h.893l.106-.105Z",
    fill: "#414e52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2792",
    "data-name": "\\uD328\\uC2A4 2792",
    d: "M601.127,9002.007h-.893l-.106.105.106.105h.893l.106-.105Z",
    fill: "#414e52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2793",
    "data-name": "\\uD328\\uC2A4 2793",
    d: "M601.127,9004.359h-.893l-.106.106.106.1h.893l.106-.1Z",
    fill: "#414e52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2794",
    "data-name": "\\uD328\\uC2A4 2794",
    d: "M600.093,9002.148l-.106.105v.894l.106.105.1-.105v-.894Z",
    fill: "#414e52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2795",
    "data-name": "\\uD328\\uC2A4 2795",
    d: "M601.269,9002.148l-.106.105v.894l.106.105.105-.105v-.894Z",
    fill: "#414e52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2796",
    "data-name": "\\uD328\\uC2A4 2796",
    d: "M600.093,9003.325l-.106.105v.894l.106.105.1-.105v-.894Z",
    fill: "#414e52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2797",
    "data-name": "\\uD328\\uC2A4 2797",
    d: "M601.269,9003.325l-.106.105v.894l.106.105.105-.105v-.894Z",
    fill: "#414e52"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_431",
    "data-name": "\\uC0AC\\uAC01\\uD615 431",
    width: 0.21,
    height: 0.21,
    transform: "translate(599.435 9004.359)",
    fill: "#414e52"
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2798",
    "data-name": "\\uD328\\uC2A4 2798",
    d: "M606.814,9003.184h-.893l-.106.105.106.105h.893l.105-.105Z",
    fill: "#414e52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2799",
    "data-name": "\\uD328\\uC2A4 2799",
    d: "M606.814,9002.007h-.893l-.106.105.106.105h.893l.105-.105Z",
    fill: "#414e52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2800",
    "data-name": "\\uD328\\uC2A4 2800",
    d: "M606.814,9004.359h-.893l-.106.106.106.1h.893l.105-.1Z",
    fill: "#414e52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2801",
    "data-name": "\\uD328\\uC2A4 2801",
    d: "M605.779,9002.148l-.105.105v.894l.105.105.106-.105v-.894Z",
    fill: "#414e52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2802",
    "data-name": "\\uD328\\uC2A4 2802",
    d: "M606.956,9002.148l-.106.105v.894l.106.105.106-.105v-.894Z",
    fill: "#414e52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2803",
    "data-name": "\\uD328\\uC2A4 2803",
    d: "M605.779,9003.325l-.105.105v.894l.105.105.106-.105v-.894Z",
    fill: "#414e52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2804",
    "data-name": "\\uD328\\uC2A4 2804",
    d: "M606.956,9003.325l-.106.105v.894l.106.105.106-.105v-.894Z",
    fill: "#414e52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2805",
    "data-name": "\\uD328\\uC2A4 2805",
    d: "M605.116,9003.184h-.894l-.105.105.105.105h.894l.1-.105Z",
    fill: "#414e52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2806",
    "data-name": "\\uD328\\uC2A4 2806",
    d: "M605.116,9002.007h-.894l-.105.105.105.105h.894l.1-.105Z",
    fill: "#414e52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2807",
    "data-name": "\\uD328\\uC2A4 2807",
    d: "M605.116,9004.359h-.894l-.105.106.105.1h.894l.1-.1Z",
    fill: "#414e52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2808",
    "data-name": "\\uD328\\uC2A4 2808",
    d: "M604.081,9002.148l-.106.105v.894l.106.105.1-.105v-.894Z",
    fill: "#414e52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2809",
    "data-name": "\\uD328\\uC2A4 2809",
    d: "M605.257,9002.148l-.106.105v.894l.106.105.105-.105v-.894Z",
    fill: "#414e52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2810",
    "data-name": "\\uD328\\uC2A4 2810",
    d: "M604.081,9003.325l-.106.105v.894l.106.105.1-.105v-.894Z",
    fill: "#414e52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2811",
    "data-name": "\\uD328\\uC2A4 2811",
    d: "M605.257,9003.325l-.106.105v.894l.106.105.105-.105v-.894Z",
    fill: "#414e52"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1353",
    "data-name": "\\uADF8\\uB8F9 1353"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2812",
    "data-name": "\\uD328\\uC2A4 2812",
    d: "M596.157,9012.523a1.354,1.354,0,1,1,1.354-1.355A1.357,1.357,0,0,1,596.157,9012.523Zm0-2.619a1.264,1.264,0,1,0,1.264,1.264A1.266,1.266,0,0,0,596.157,9009.9Z",
    fill: "#d4dbdf"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1354",
    "data-name": "\\uADF8\\uB8F9 1354"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2813",
    "data-name": "\\uD328\\uC2A4 2813",
    d: "M599.865,9012.523a1.354,1.354,0,1,1,1.354-1.355A1.356,1.356,0,0,1,599.865,9012.523Zm0-2.619a1.264,1.264,0,1,0,1.264,1.264A1.265,1.265,0,0,0,599.865,9009.9Z",
    fill: "#d4dbdf"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1355",
    "data-name": "\\uADF8\\uB8F9 1355"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2814",
    "data-name": "\\uD328\\uC2A4 2814",
    d: "M603.572,9012.523a1.354,1.354,0,1,1,1.355-1.355A1.357,1.357,0,0,1,603.572,9012.523Zm0-2.619a1.264,1.264,0,1,0,1.265,1.264A1.266,1.266,0,0,0,603.572,9009.9Z",
    fill: "#d4dbdf"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1356",
    "data-name": "\\uADF8\\uB8F9 1356"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2815",
    "data-name": "\\uD328\\uC2A4 2815",
    d: "M607.279,9012.523a1.354,1.354,0,1,1,1.356-1.355A1.357,1.357,0,0,1,607.279,9012.523Zm0-2.619a1.264,1.264,0,1,0,1.265,1.264A1.265,1.265,0,0,0,607.279,9009.9Z",
    fill: "#d4dbdf"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1357",
    "data-name": "\\uADF8\\uB8F9 1357"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2816",
    "data-name": "\\uD328\\uC2A4 2816",
    d: "M593.608,9002.64a.633.633,0,1,1-.633-.633A.634.634,0,0,1,593.608,9002.64Z",
    fill: "#29333f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2817",
    "data-name": "\\uD328\\uC2A4 2817",
    d: "M593.518,9002.64a.543.543,0,1,1-.543-.543A.543.543,0,0,1,593.518,9002.64Z",
    fill: "red",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2818",
    "data-name": "\\uD328\\uC2A4 2818",
    d: "M593.382,9002.64a.407.407,0,1,1-.407-.406A.407.407,0,0,1,593.382,9002.64Z",
    fill: "red",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2819",
    "data-name": "\\uD328\\uC2A4 2819",
    d: "M593.273,9002.64a.3.3,0,1,1-.3-.3A.3.3,0,0,1,593.273,9002.64Z",
    fill: "red"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1358",
    "data-name": "\\uADF8\\uB8F9 1358"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2820",
    "data-name": "\\uD328\\uC2A4 2820",
    d: "M593.608,9005.76a.633.633,0,1,1-.633-.633A.633.633,0,0,1,593.608,9005.76Z",
    fill: "#29333f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2821",
    "data-name": "\\uD328\\uC2A4 2821",
    d: "M593.518,9005.76a.543.543,0,1,1-.543-.542A.544.544,0,0,1,593.518,9005.76Z",
    fill: "lime",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2822",
    "data-name": "\\uD328\\uC2A4 2822",
    d: "M593.382,9005.76a.407.407,0,1,1-.407-.407A.407.407,0,0,1,593.382,9005.76Z",
    fill: "lime",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2823",
    "data-name": "\\uD328\\uC2A4 2823",
    d: "M593.273,9005.76a.3.3,0,1,1-.3-.3A.3.3,0,0,1,593.273,9005.76Z",
    fill: "lime"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1359",
    "data-name": "\\uADF8\\uB8F9 1359"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2824",
    "data-name": "\\uD328\\uC2A4 2824",
    d: "M610.919,9002.64a.633.633,0,1,1-.633-.633A.634.634,0,0,1,610.919,9002.64Z",
    fill: "#29333f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2825",
    "data-name": "\\uD328\\uC2A4 2825",
    d: "M610.829,9002.64a.543.543,0,1,1-.543-.543A.543.543,0,0,1,610.829,9002.64Z",
    fill: "lime",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2826",
    "data-name": "\\uD328\\uC2A4 2826",
    d: "M610.693,9002.64a.407.407,0,1,1-.407-.406A.407.407,0,0,1,610.693,9002.64Z",
    fill: "lime",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2827",
    "data-name": "\\uD328\\uC2A4 2827",
    d: "M610.584,9002.64a.3.3,0,1,1-.3-.3A.3.3,0,0,1,610.584,9002.64Z",
    fill: "lime"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1360",
    "data-name": "\\uADF8\\uB8F9 1360"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2828",
    "data-name": "\\uD328\\uC2A4 2828",
    d: "M610.919,9005.76a.633.633,0,1,1-.633-.633A.633.633,0,0,1,610.919,9005.76Z",
    fill: "#29333f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2829",
    "data-name": "\\uD328\\uC2A4 2829",
    d: "M610.829,9005.76a.543.543,0,1,1-.543-.542A.544.544,0,0,1,610.829,9005.76Z",
    fill: "lime",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2830",
    "data-name": "\\uD328\\uC2A4 2830",
    d: "M610.693,9005.76a.407.407,0,1,1-.407-.407A.407.407,0,0,1,610.693,9005.76Z",
    fill: "lime",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2831",
    "data-name": "\\uD328\\uC2A4 2831",
    d: "M610.584,9005.76a.3.3,0,1,1-.3-.3A.3.3,0,0,1,610.584,9005.76Z",
    fill: "lime"
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2832",
    "data-name": "\\uD328\\uC2A4 2832",
    d: "M596.891,9006.562a.394.394,0,1,1-.394-.395A.394.394,0,0,1,596.891,9006.562Z",
    fill: "#414e52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2833",
    "data-name": "\\uD328\\uC2A4 2833",
    d: "M598.232,9006.562a.394.394,0,1,1-.394-.395A.394.394,0,0,1,598.232,9006.562Z",
    fill: "#414e52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2834",
    "data-name": "\\uD328\\uC2A4 2834",
    d: "M607.156,9006.562a.394.394,0,1,1-.394-.395A.394.394,0,0,1,607.156,9006.562Z",
    fill: "#414e52"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1369",
    "data-name": "\\uADF8\\uB8F9 1369",
    transform: "translate(-276.197 -8671.303)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1364",
    "data-name": "\\uADF8\\uB8F9 1364"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1362",
    "data-name": "\\uADF8\\uB8F9 1362"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2835",
    "data-name": "\\uD328\\uC2A4 2835",
    d: "M1012.529,8992.648h-4.152V8953.2a2.076,2.076,0,0,1,2.076-2.076h0a2.075,2.075,0,0,1,2.076,2.076Z",
    fill: "#fed73c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2836",
    "data-name": "\\uD328\\uC2A4 2836",
    d: "M1015.051,8987.732h-9.2a1.968,1.968,0,0,1-1.967-1.968h0a1.967,1.967,0,0,1,1.967-1.967h9.2a1.967,1.967,0,0,1,1.967,1.967h0A1.968,1.968,0,0,1,1015.051,8987.732Z",
    fill: "#eab50a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2837",
    "data-name": "\\uD328\\uC2A4 2837",
    d: "M1015.051,8981.176h-9.2a1.967,1.967,0,0,1-1.967-1.967h0a1.967,1.967,0,0,1,1.967-1.967h9.2a1.967,1.967,0,0,1,1.967,1.967h0A1.967,1.967,0,0,1,1015.051,8981.176Z",
    fill: "#eab50a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2838",
    "data-name": "\\uD328\\uC2A4 2838",
    d: "M1015.051,8974.62h-9.2a1.967,1.967,0,0,1-1.967-1.967h0a1.968,1.968,0,0,1,1.967-1.968h9.2a1.968,1.968,0,0,1,1.967,1.968h0A1.967,1.967,0,0,1,1015.051,8974.62Z",
    fill: "#eab50a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2839",
    "data-name": "\\uD328\\uC2A4 2839",
    d: "M1015.051,8968.064h-9.2a1.968,1.968,0,0,1-1.967-1.968h0a1.967,1.967,0,0,1,1.967-1.967h9.2a1.967,1.967,0,0,1,1.967,1.967h0A1.968,1.968,0,0,1,1015.051,8968.064Z",
    fill: "#eab50a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1363",
    "data-name": "\\uADF8\\uB8F9 1363"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2840",
    "data-name": "\\uD328\\uC2A4 2840",
    d: "M1033.4,8992.648h-4.152V8953.2a2.075,2.075,0,0,1,2.076-2.076h0a2.076,2.076,0,0,1,2.076,2.076Z",
    fill: "#fed73c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2841",
    "data-name": "\\uD328\\uC2A4 2841",
    d: "M1035.921,8987.732h-9.2a1.968,1.968,0,0,1-1.967-1.968h0a1.967,1.967,0,0,1,1.967-1.967h9.2a1.967,1.967,0,0,1,1.967,1.967h0A1.968,1.968,0,0,1,1035.921,8987.732Z",
    fill: "#eab50a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2842",
    "data-name": "\\uD328\\uC2A4 2842",
    d: "M1035.921,8981.176h-9.2a1.967,1.967,0,0,1-1.967-1.967h0a1.967,1.967,0,0,1,1.967-1.967h9.2a1.967,1.967,0,0,1,1.967,1.967h0A1.967,1.967,0,0,1,1035.921,8981.176Z",
    fill: "#eab50a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2843",
    "data-name": "\\uD328\\uC2A4 2843",
    d: "M1035.921,8974.62h-9.2a1.967,1.967,0,0,1-1.967-1.967h0a1.968,1.968,0,0,1,1.967-1.968h9.2a1.968,1.968,0,0,1,1.967,1.968h0A1.967,1.967,0,0,1,1035.921,8974.62Z",
    fill: "#eab50a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2844",
    "data-name": "\\uD328\\uC2A4 2844",
    d: "M1035.921,8968.064h-9.2a1.968,1.968,0,0,1-1.967-1.968h0a1.967,1.967,0,0,1,1.967-1.967h9.2a1.967,1.967,0,0,1,1.967,1.967h0A1.968,1.968,0,0,1,1035.921,8968.064Z",
    fill: "#eab50a"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_432",
    "data-name": "\\uC0AC\\uAC01\\uD615 432",
    width: 4.589,
    height: 15.297,
    transform: "translate(1034.853 9055.94)",
    fill: "#eab50a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_433",
    "data-name": "\\uC0AC\\uAC01\\uD615 433",
    width: 4.589,
    height: 15.297,
    transform: "translate(1002.334 9055.94)",
    fill: "#eab50a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_434",
    "data-name": "\\uC0AC\\uAC01\\uD615 434",
    width: 60.096,
    height: 66.27,
    transform: "translate(990.84 8992.648)",
    fill: "#fed73c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1365",
    "data-name": "\\uADF8\\uB8F9 1365"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2845",
    "data-name": "\\uD328\\uC2A4 2845",
    d: "M999.769,9051.65h0a2.564,2.564,0,0,1-2.564-2.564v-46.6a2.565,2.565,0,0,1,2.564-2.565h0a2.566,2.566,0,0,1,2.565,2.565v46.6A2.565,2.565,0,0,1,999.769,9051.65Z",
    fill: "#eab50a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2846",
    "data-name": "\\uD328\\uC2A4 2846",
    d: "M1005.8,9051.65h0a2.564,2.564,0,0,1-2.564-2.564v-46.6a2.565,2.565,0,0,1,2.564-2.565h0a2.566,2.566,0,0,1,2.565,2.565v46.6A2.565,2.565,0,0,1,1005.8,9051.65Z",
    fill: "#eab50a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2847",
    "data-name": "\\uD328\\uC2A4 2847",
    d: "M1011.837,9051.65h0a2.564,2.564,0,0,1-2.564-2.564v-46.6a2.565,2.565,0,0,1,2.564-2.565h0a2.565,2.565,0,0,1,2.564,2.565v46.6A2.564,2.564,0,0,1,1011.837,9051.65Z",
    fill: "#eab50a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2848",
    "data-name": "\\uD328\\uC2A4 2848",
    d: "M1017.871,9051.65h0a2.564,2.564,0,0,1-2.564-2.564v-46.6a2.565,2.565,0,0,1,2.564-2.565h0a2.565,2.565,0,0,1,2.564,2.565v46.6A2.564,2.564,0,0,1,1017.871,9051.65Z",
    fill: "#eab50a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2849",
    "data-name": "\\uD328\\uC2A4 2849",
    d: "M1029.939,9051.65h0a2.564,2.564,0,0,1-2.564-2.564v-46.6a2.565,2.565,0,0,1,2.564-2.565h0a2.565,2.565,0,0,1,2.564,2.565v46.6A2.565,2.565,0,0,1,1029.939,9051.65Z",
    fill: "#eab50a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2850",
    "data-name": "\\uD328\\uC2A4 2850",
    d: "M1023.905,9051.65h0a2.564,2.564,0,0,1-2.564-2.564v-46.6a2.565,2.565,0,0,1,2.564-2.565h0a2.565,2.565,0,0,1,2.564,2.565v46.6A2.564,2.564,0,0,1,1023.905,9051.65Z",
    fill: "#eab50a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2851",
    "data-name": "\\uD328\\uC2A4 2851",
    d: "M1042.007,9051.65h0a2.565,2.565,0,0,1-2.565-2.564v-46.6a2.565,2.565,0,0,1,2.565-2.565h0a2.565,2.565,0,0,1,2.564,2.565v46.6A2.565,2.565,0,0,1,1042.007,9051.65Z",
    fill: "#eab50a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2852",
    "data-name": "\\uD328\\uC2A4 2852",
    d: "M1035.973,9051.65h0a2.564,2.564,0,0,1-2.564-2.564v-46.6a2.565,2.565,0,0,1,2.564-2.565h0a2.565,2.565,0,0,1,2.564,2.565v46.6A2.564,2.564,0,0,1,1035.973,9051.65Z",
    fill: "#eab50a"
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2853",
    "data-name": "\\uD328\\uC2A4 2853",
    d: "M1048.7,8990.545H993.08a4.207,4.207,0,0,0-4.207,4.207h64.03A4.207,4.207,0,0,0,1048.7,8990.545Z",
    fill: "#eab50a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2854",
    "data-name": "\\uD328\\uC2A4 2854",
    d: "M1052.9,9056.815h-64.03a4.207,4.207,0,0,0,4.207,4.206H1048.7a4.207,4.207,0,0,0,4.207-4.206Z",
    fill: "#eab50a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1367",
    "data-name": "\\uADF8\\uB8F9 1367"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1366",
    "data-name": "\\uADF8\\uB8F9 1366"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_435",
    "data-name": "\\uC0AC\\uAC01\\uD615 435",
    width: 15.516,
    height: 38.899,
    transform: "translate(1048.449 9006.184)",
    fill: "#eab50a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_436",
    "data-name": "\\uC0AC\\uAC01\\uD615 436",
    width: 7.758,
    height: 38.899,
    transform: "translate(1048.449 9006.184)",
    fill: "#f9e08f"
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2855",
    "data-name": "\\uD328\\uC2A4 2855",
    d: "M1048.449,8998.726h2.731a5.027,5.027,0,0,1,5.027,5.027v2.431",
    fill: "none",
    stroke: "#fed73c",
    strokeMiterlimit: 10,
    strokeWidth: 2.622
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2856",
    "data-name": "\\uD328\\uC2A4 2856",
    d: "M1056.056,9045.082v2.732a5.026,5.026,0,0,1-5.026,5.025H1048.6",
    fill: "none",
    stroke: "#fed73c",
    strokeMiterlimit: 10,
    strokeWidth: 2.622
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1368",
    "data-name": "\\uADF8\\uB8F9 1368"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2857",
    "data-name": "\\uD328\\uC2A4 2857",
    d: "M1013.08,9050.433l7.25-19.776h-15.154l22.651-30.95.191.095-7.271,19.842H1035.9l-22.653,30.953Z",
    fill: "#fff"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1370",
    "data-name": "\\uADF8\\uB8F9 1370",
    transform: "translate(-276.197 -8671.303)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2858",
    "data-name": "\\uD328\\uC2A4 2858",
    d: "M1086.333,8751.262l-24.376-6.867q-.764-5.7-1.472-11.424h13.081v7.462h1.368v-7.462h.683v-7.336l-16.539-4.617q-.864-7.879-1.607-15.811l-.174-1.86h-10.815l-.174,1.86q-.744,7.956-1.613,15.859l-16.534,4.568v7.336h.684v7.462h1.367v-7.462h13.082q-.7,5.732-1.473,11.426l-24.374,6.865v8.548h.683v7.474h1.368v-7.474h20.129c-3.484,23.125-7.739,45.781-12.787,67.734h4.2q1.6-6.983,3.089-14.056h35.515q1.494,7.071,3.089,14.056h4.2c-5.048-21.953-9.3-44.609-12.786-67.734h20.13v7.474h1.367v-7.474h.683Zm-23.069,28.82-9.506-10.263,6.68-7.142Q1061.779,8771.427,1063.264,8780.082Zm-7.232-49.846h-8.286c.277-2.328.572-4.646.832-6.981h6.623C1055.461,8725.59,1055.756,8727.908,1056.032,8730.236Zm.326,2.734.042.351-.285-.169-4.225,7.143-4.226-7.143-.285.169c.014-.117.027-.234.042-.351Zm-15.205,53.679h21.473l-10.736,8.027Zm-.46-2.734,11.2-12.088,11.2,12.088Zm11.2-16.113-.005,0-7.483-8h14.974l-7.481,8Zm0-22.137.038-.064,7.244,11.475h-14.565l7.245-11.475Zm1.6-2.708,3.376-5.706q.888,7.044,1.881,14.032Zm-6.581-5.706,3.376,5.706-5.257,8.326Q1046.016,8744.292,1046.911,8737.251Zm-3.57,25.427,6.68,7.142-9.506,10.263Q1042.008,8771.432,1043.341,8762.678Zm-4.317,25.793,10.577,7.909-14.121,10.476Q1037.336,8797.727,1039.024,8788.471Zm12.863,9.618,0,0,0,0,17.071,12.664h-34.149Zm2.292-1.709,10.576-7.909q1.685,9.258,3.544,18.385Zm16.082-46.8-6.709,6.258q-.619-4.232-1.2-8.485Zm2.541,1.37,4.7,6.13H1066.23Zm-10.755-20.709,3.343-3.816,2.765,3.816Zm10.836,0h-1.351l-2.635-3.638,3.986,1.113Zm-9.851-5.275-3.076,3.513c-.177-1.507-.362-3.01-.533-4.52Zm-9.469-17.512c.418,4.384.88,8.75,1.354,13.108l-6.052-.027c.473-4.351.934-8.706,1.351-13.081Zm-9.74,21.024-3.076-3.513,3.608-1.007C1044.185,8725.464,1044,8726.967,1043.823,8728.474Zm-2.091,1.763h-6.108l2.764-3.816Zm-10.836-2.524,3.985-1.113-2.634,3.638H1030.9Zm9.331,28.121-6.709-6.258,7.907-2.228Q1040.841,8751.6,1040.227,8755.833Zm-2.678,1.242h-11.274l4.7-6.13Zm-17.368-3.742,7.04-1.983-4.392,5.726h-2.648Zm63.416,3.742h-2.647l-4.392-5.727,7.04,1.984Z",
    fill: "#b5b5b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2859",
    "data-name": "\\uD328\\uC2A4 2859",
    d: "M1031.9,8736.117h-4.746a1.025,1.025,0,0,1,0-2.051h4.746a1.025,1.025,0,1,1,0,2.051Z",
    fill: "#878787"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2860",
    "data-name": "\\uD328\\uC2A4 2860",
    d: "M1076.623,8736.117h-4.747a1.025,1.025,0,0,1,0-2.051h4.747a1.025,1.025,0,1,1,0,2.051Z",
    fill: "#878787"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2861",
    "data-name": "\\uD328\\uC2A4 2861",
    d: "M1031.9,8739.16h-4.746a1.025,1.025,0,0,1,0-2.051h4.746a1.025,1.025,0,1,1,0,2.051Z",
    fill: "#878787"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2862",
    "data-name": "\\uD328\\uC2A4 2862",
    d: "M1076.623,8739.16h-4.747a1.025,1.025,0,0,1,0-2.051h4.747a1.025,1.025,0,1,1,0,2.051Z",
    fill: "#878787"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2863",
    "data-name": "\\uD328\\uC2A4 2863",
    d: "M1021.187,8762.8h-4.746a1.025,1.025,0,1,1,0-2.051h4.746a1.025,1.025,0,0,1,0,2.051Z",
    fill: "#878787"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2864",
    "data-name": "\\uD328\\uC2A4 2864",
    d: "M1087.338,8762.8h-4.746a1.025,1.025,0,1,1,0-2.051h4.746a1.025,1.025,0,1,1,0,2.051Z",
    fill: "#878787"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2865",
    "data-name": "\\uD328\\uC2A4 2865",
    d: "M1021.187,8765.839h-4.746a1.025,1.025,0,1,1,0-2.051h4.746a1.025,1.025,0,0,1,0,2.051Z",
    fill: "#878787"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2866",
    "data-name": "\\uD328\\uC2A4 2866",
    d: "M1087.338,8765.839h-4.746a1.025,1.025,0,1,1,0-2.051h4.746a1.025,1.025,0,1,1,0,2.051Z",
    fill: "#878787"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1371",
    "data-name": "\\uADF8\\uB8F9 1371",
    transform: "translate(-276.197 -8671.303)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2867",
    "data-name": "\\uD328\\uC2A4 2867",
    d: "M1025.333,8751.262l-24.376-6.867q-.763-5.7-1.472-11.424h13.081v7.462h1.368v-7.462h.683v-7.336l-16.539-4.617q-.864-7.879-1.607-15.811l-.174-1.86H985.482l-.174,1.86q-.744,7.956-1.613,15.859l-16.534,4.568v7.336h.684v7.462h1.367v-7.462h13.082q-.7,5.732-1.473,11.426l-24.374,6.865v8.548h.683v7.474H958.5v-7.474h20.129c-3.484,23.125-7.739,45.781-12.787,67.734h4.2q1.6-6.983,3.089-14.056h35.515q1.494,7.071,3.089,14.056h4.2c-5.048-21.953-9.3-44.609-12.786-67.734h20.13v7.474h1.367v-7.474h.683Zm-23.069,28.82-9.506-10.263,6.68-7.142Q1000.779,8771.427,1002.264,8780.082Zm-7.232-49.846h-8.286c.277-2.328.572-4.646.832-6.981H994.2C994.461,8725.59,994.756,8727.908,995.032,8730.236Zm.326,2.734.042.351-.285-.169-4.225,7.143-4.226-7.143-.285.169c.014-.117.027-.234.042-.351Zm-15.2,53.679h21.473l-10.736,8.027Zm-.46-2.734,11.2-12.088,11.2,12.088Zm11.2-16.113-.005,0-7.483-8h14.974l-7.481,8Zm0-22.137.038-.064,7.244,11.475H983.607l7.245-11.475Zm1.6-2.708,3.376-5.706q.888,7.044,1.881,14.032Zm-6.581-5.706,3.376,5.706-5.257,8.326Q985.016,8744.292,985.911,8737.251Zm-3.57,25.427,6.68,7.142-9.506,10.263Q981.008,8771.432,982.341,8762.678Zm-4.317,25.793,10.577,7.909-14.121,10.476Q976.335,8797.727,978.024,8788.471Zm12.863,9.618,0,0,0,0,17.071,12.664H973.815Zm2.292-1.709,10.576-7.909q1.684,9.258,3.544,18.385Zm16.082-46.8-6.709,6.258q-.62-4.232-1.2-8.485Zm2.541,1.37,4.7,6.13H1005.23Zm-10.755-20.709,3.343-3.816,2.765,3.816Zm10.836,0h-1.351l-2.635-3.638,3.986,1.113Zm-9.851-5.275-3.076,3.513c-.177-1.507-.362-3.01-.533-4.52Zm-9.469-17.512c.418,4.384.88,8.75,1.354,13.108l-6.052-.027c.473-4.351.934-8.706,1.351-13.081Zm-9.74,21.024-3.076-3.513,3.608-1.007C983.185,8725.464,983,8726.967,982.823,8728.474Zm-2.091,1.763h-6.108l2.764-3.816Zm-10.836-2.524,3.985-1.113-2.634,3.638H969.9Zm9.331,28.121-6.709-6.258,7.907-2.228Q979.842,8751.6,979.227,8755.833Zm-2.678,1.242H965.275l4.7-6.13Zm-17.368-3.742,7.04-1.983-4.392,5.726h-2.648Zm63.416,3.742h-2.647l-4.392-5.727,7.04,1.984Z",
    fill: "#b5b5b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2868",
    "data-name": "\\uD328\\uC2A4 2868",
    d: "M970.9,8736.117h-4.746a1.025,1.025,0,0,1,0-2.051H970.9a1.025,1.025,0,1,1,0,2.051Z",
    fill: "#878787"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2869",
    "data-name": "\\uD328\\uC2A4 2869",
    d: "M1015.623,8736.117h-4.747a1.025,1.025,0,0,1,0-2.051h4.747a1.025,1.025,0,1,1,0,2.051Z",
    fill: "#878787"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2870",
    "data-name": "\\uD328\\uC2A4 2870",
    d: "M970.9,8739.16h-4.746a1.025,1.025,0,0,1,0-2.051H970.9a1.025,1.025,0,1,1,0,2.051Z",
    fill: "#878787"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2871",
    "data-name": "\\uD328\\uC2A4 2871",
    d: "M1015.623,8739.16h-4.747a1.025,1.025,0,0,1,0-2.051h4.747a1.025,1.025,0,1,1,0,2.051Z",
    fill: "#878787"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2872",
    "data-name": "\\uD328\\uC2A4 2872",
    d: "M960.187,8762.8h-4.746a1.025,1.025,0,1,1,0-2.051h4.746a1.025,1.025,0,0,1,0,2.051Z",
    fill: "#878787"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2873",
    "data-name": "\\uD328\\uC2A4 2873",
    d: "M1026.338,8762.8h-4.746a1.025,1.025,0,1,1,0-2.051h4.746a1.025,1.025,0,1,1,0,2.051Z",
    fill: "#878787"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2874",
    "data-name": "\\uD328\\uC2A4 2874",
    d: "M960.187,8765.839h-4.746a1.025,1.025,0,1,1,0-2.051h4.746a1.025,1.025,0,0,1,0,2.051Z",
    fill: "#878787"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2875",
    "data-name": "\\uD328\\uC2A4 2875",
    d: "M1026.338,8765.839h-4.746a1.025,1.025,0,1,1,0-2.051h4.746a1.025,1.025,0,1,1,0,2.051Z",
    fill: "#878787"
  }))), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_437",
    "data-name": "\\uC0AC\\uAC01\\uD615 437",
    width: 152,
    height: 5,
    transform: "translate(671.271 153.825)",
    fill: "#b5b5b5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2876",
    "data-name": "\\uD328\\uC2A4 2876",
    d: "M951.469,9040.724l14.5-9.151-14.5-9.392Z",
    transform: "translate(-276.197 -8671.303)",
    fill: "#0071bc"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2877",
    "data-name": "\\uD328\\uC2A4 2877",
    d: "M753.469,9040.724l14.5-9.151-14.5-9.392Z",
    transform: "translate(-276.197 -8671.303)",
    fill: "#0071bc"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2878",
    "data-name": "\\uD328\\uC2A4 2878",
    d: "M497.873,8935.128l9.152,14.5,9.391-14.5Z",
    transform: "translate(-276.197 -8671.303)",
    fill: "#0071bc"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2879",
    "data-name": "\\uD328\\uC2A4 2879",
    d: "M1031.3,8879.128l-9.152-14.5-9.391,14.5Z",
    transform: "translate(-276.197 -8671.303)",
    fill: "#f44522"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_29",
    "data-name": "\\uD0C0\\uC6D0 29",
    cx: 14,
    cy: 14,
    r: 14,
    transform: "translate(391.271 346.825)",
    fill: "url(#radial-gradient)"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1372",
    "data-name": "\\uADF8\\uB8F9 1372",
    transform: "translate(-276.197 -8671.303)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2880",
    "data-name": "\\uD328\\uC2A4 2880",
    d: "M684.429,9052.088q1.125,1.126,2.253,2.252a.624.624,0,0,1,.22.714c-.116.3-.368.324-.633.324-.536,0-1.073.015-1.608-.009-.27-.012-.3.082-.271.317.279,2.295.547,4.589.819,6.884.043.363.088.728.124,1.093a.519.519,0,0,1-.56.636q-3.1.007-6.192,0c-.421,0-.618-.249-.567-.684q.456-3.916.918-7.83a1.043,1.043,0,0,1,.02-.147c.05-.2-.009-.273-.232-.267-.565.017-1.131.007-1.7.006-.25,0-.471-.043-.58-.315a.577.577,0,0,1,.168-.672q2.3-2.307,4.61-4.609a.579.579,0,0,1,.911.014Q683.284,9050.938,684.429,9052.088Z",
    fill: "#fe3c38"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceholder5);
export default __webpack_public_path__ + "static/media/placeholder5.8f2d5d7519f27fbe10ea31972ea75c24.svg";
export { ForwardRef as ReactComponent };